import Img1 from 'assets/innvolight/OCT-Imaging-Catheter/Img1.png'
import Img2 from 'assets/innvolight/OCT-Imaging-Catheter/Img2.png'
// import InnvoCrossLogo from 'assets/innvolight/OCT-Imaging-Catheter/InnvoCrossLogo.png'
import InnvoCrossLogo from 'assets/innvolight/OCT-Imaging-Catheter/InnvoCrossLogo-orange.png'
import MainProductImg from 'assets/innvolight/OCT-Imaging-Catheter/MainProductImg.png'

export default function OctImagingCatheter() {
  return (
    <div className="relative h-auto bg-center bg-slate-100">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div className="flex flex-col gap-10 w-full">
          <div className="flex flex-col gap-4 justify-start w-full gsap-opacity-trans-appear">
            <div className="w-full max-w-[208px]">
              <img
                src={InnvoCrossLogo}
                className="object-contain w-full h-full"
                alt=""
              />
            </div>
            <h3 className="text-2xl font-bold text-left text-black sm:text-2xl md:text-3xl">
              <span className="text-orange">OCT</span> Imaging Catheter
            </h3>
          </div>
          <div className="flex flex-col w-full">
            {/* <div className="mx-auto w-full max-w-2xl h-full">
              <img
                src={MainProductImg}
                className="object-contain w-full h-full gsap-scale"
                alt=""
              />
            </div> */}

            <div className="flex flex-col-reverse gap-0 mx-auto w-full max-w-7xl gsap-stagger-bounce-parent md:flex-row">
              <div className="flex flex-col flex-1 gap-6">
                <div className="flex flex-col gap-2 items-center gsap-stagger-bounce">
                  <div className="w-full max-w-[420px] flex flex-col gap-5">
                    <p className="text-lg font-bold text-left text-black sm:text-xl">
                      OCT Imaging Lens
                    </p>
                    <img
                      src={Img1}
                      className="object-contain w-full h-full"
                      alt=""
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 items-center gsap-stagger-bounce">
                  <div className="w-full max-w-[420px] flex flex-col gap-5">
                    <p className="text-lg font-bold text-left text-black sm:text-xl">
                      OCT Catheter Tip
                    </p>
                    <img
                      src={Img2}
                      className="object-contain w-full h-full"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="w-full h-full max-w-[600px]">
                  <img
                    src={MainProductImg}
                    className="object-contain w-full h-full gsap-scale"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full">
            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-5 gsap-opacity-trans-appear">
                <h4 className="text-xl font-bold md:text-2xl text-orange">
                  Excellent lesion crossing ability
                </h4>
                <ul className="flex flex-col gap-5 pl-5 list-disc">
                  <li className="text-base sm:text-lg md:text-xl">
                    Low-profile:{' '}
                    <span className="font-bold">2.58Fr (0.86mm)</span>
                  </li>
                  <li className="text-base sm:text-lg md:text-xl">
                    <span className="font-bold">Hydrophobic</span> coating
                  </li>
                  <li className="text-base sm:text-lg md:text-xl">
                    Enhanced out-layer of distal catheter
                  </li>
                </ul>
              </div>
              <div className="flex flex-col gap-5 gsap-opacity-trans-appear">
                <h4 className="text-xl font-bold md:text-2xl text-orange">
                  Outstanding capability to observe more distant artery
                </h4>
                <ul className="flex flex-col gap-5 pl-5 list-disc">
                  <li className="text-base sm:text-lg md:text-xl">
                    Shorter distance from{' '}
                    <span className="font-bold">Lens to Tip: 20mm</span>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col gap-5 gsap-opacity-trans-appear">
                <h4 className="text-xl font-bold md:text-2xl text-orange">
                  Compatible with OCT angiographic co-registration
                </h4>
                <ul className="flex flex-col gap-5 pl-5 list-disc">
                  <li className="text-base sm:text-lg md:text-xl">
                    Lens marker indicating{' '}
                    <span className="font-bold">lens position.</span>
                  </li>
                  <li className="text-base sm:text-lg md:text-xl">
                    Seamless <span className="font-bold">ACR integration</span>{' '}
                    for efficient OCT workflow.
                  </li>
                  <li className="text-base sm:text-lg md:text-xl">
                    <span className="font-bold">Reduces operation time</span>{' '}
                    with bookmark option.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
